import type {
  EntityObject,
  MiddlewareStates,
  OverreactRequestShape,
  OverreactSpec,
  RequestConfig,
} from '../public-types';
import type { RequestContract } from '../spec';

export class OverreactRequest<
  TVariables extends object = object,
  TData = unknown,
  TResult = unknown,
  TEntity extends EntityObject = EntityObject,
> implements OverreactRequestShape<TVariables, TData, TResult, TEntity> {
  id: OverreactRequestShape<TVariables, TData, TResult, TEntity>['id'];
  requestContract: RequestContract<TVariables, TData>;
  variables: TVariables;
  data: TData;
  spec: OverreactSpec<TVariables, TData, TResult, TEntity>;
  mergedConfig?: RequestConfig<TResult>;
  componentName?: string;
  dataCb?: OverreactRequestShape<TVariables, TData, TResult, TEntity>['dataCb'];
  errorCb?: OverreactRequestShape<TVariables, TData, TResult, TEntity>['errorCb'];
  middlewareStates?: MiddlewareStates;

  constructor(options: OverreactRequestShape<TVariables, TData, TResult, TEntity>) {
    Object.assign(this, options);
    if (!this.id || !this.requestContract) {
      throw new Error('id and requestContract are required fields to build request object');
    }
  }
}
